import { render, staticRenderFns } from "./BtnSign.vue?vue&type=template&id=73144ff6&scoped=true&"
import script from "./BtnSign.vue?vue&type=script&lang=js&"
export * from "./BtnSign.vue?vue&type=script&lang=js&"
import style0 from "./BtnSign.vue?vue&type=style&index=0&id=73144ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73144ff6",
  null
  
)

export default component.exports